import { Colors, FontSize } from "~/jsx/theme";
import { XBadge } from "./XBadge";
import { XTypography } from "./XTypography";

export const XBadgeCounter = ({
  value,
  size = 16,
}: {
  value: string | number;
  size?: number;
}) => {
  return (
    <XBadge>
      <XTypography
        style={{
          backgroundColor: Colors.common.white,
          width: size,
          height: size,
          borderRadius: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: FontSize.px12,
          border: `solid 1px ${Colors.common.black}`,
        }}
      >
        {value}
      </XTypography>
    </XBadge>
  );
};
